<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
      <b-navbar-brand href="#">OFDIT Projects</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/"
            ><b-icon icon="house-fill"></b-icon> Home</b-nav-item
          >
          <b-nav-item
            href="https://ofditprojects.sps.cuny.edu/help/"
            target="_blank"
          >
            <b-icon icon="question-circle-fill"></b-icon> Help</b-nav-item
          >
          <div v-if="isOfdit">
            <b-nav-item-dropdown right no-caret>
              <template v-slot:button-content="">
                <b-icon icon="bar-chart-steps"></b-icon> CourseDev</template
              >
              <b-dropdown-item to="/projects">Statusboard</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                v-if="isOfdit"
                to="/project-tools/create-dev-site"
                >Create dev site
                <b-badge
                  v-if="numberOfDevSitesToBeCreated > 0"
                  variant="dark"
                  >{{ numberOfDevSitesToBeCreated }}</b-badge
                ></b-dropdown-item
              >
              <b-dropdown-item
                :disabled="!currentUser.is_grizzly_admin"
                to="/project-tools/ofdit-approval"
                >Approve request
                <b-badge
                  v-if="dataImportedProjects.length > 0"
                  variant="dark"
                  >{{ dataImportedProjects.length }}</b-badge
                ></b-dropdown-item
              >
              <b-dropdown-item
                :disabled="!currentUser.is_grizzly_admin"
                to="/admin/assign-lead"
                >Assign lead
                <b-badge
                  v-if="projectsToBeAssigned.length > 0"
                  variant="dark"
                  >{{ projectsToBeAssigned.length }}</b-badge
                >
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
          <div v-else>
            <b-nav-item to="/projects">
              <b-icon icon="bar-chart-steps"></b-icon> Statusboard</b-nav-item
            >
          </div>
          <b-nav-item to="/courseprep">
            <b-icon icon="card-checklist"></b-icon>
            CoursePrep</b-nav-item
          >
          <b-nav-item to="/payments">
            <b-icon icon="wallet2"></b-icon>
            Payments</b-nav-item
          >
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            v-if="this.$store.getters.currentUser.is_grizzly_admin"
            right
            no-caret
          >
            <template v-slot:button-content="">
              <b-icon icon="tools"></b-icon> Admin</template
            >
            <b-dropdown-item to="/admin/impersonate"
              >Impersonate user</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item
            v-if="this.$store.state.courseDev.user.isLoggedIn"
            @click="logout"
          >
            <b-icon icon="box-arrow-right"></b-icon> Logout,
            {{ this.$store.getters.currentUser.first_name }}</b-nav-item
          >
          <b-nav-item v-else to="login">
            <b-icon icon="box-arrow-in-right"></b-icon> Login</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    computed: {
      isOfdit() {
        return this.$store.getters.isOfdit
      },
      currentUser() {
        return this.$store.getters.currentUser
      },
      numberOfDevSitesToBeCreated() {
        return this.$store.getters.numberOfDevSitesToBeCreated
      },
      projectsToBeAssigned() {
        return this.$store.getters.projectsToBeAssigned
      },
      dataImportedProjects() {
        return this.$store.getters.dataImportedProjects
      },
    },
    methods: {
      logout: async function() {
        try {
          await this.$store.dispatch('logout')
          this.$router.push({ name: 'home' })
        } catch (err) {
          console.error(err)
        }
      },
    },
  }
</script>

<style scoped>
  .navbar-brand {
    font-family: 'Fira Sans';
  }
</style>
